import LeftGroupList from "@/components/LeftGroupList";
import ButtonDialog from "@/components/ButtonDialog";
import api from "@/api";
import PriceCalculateImage from "@/components/subject/PriceCalculate/PriceCalculateImage";
export default {
  name: "PriceCalculateQuestionView",
  components: {
    PriceCalculateImage,
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    deleteGroup() {
      api.deletePriceCalculateGroup(this.groupId).then(() => {
        this.init();
      });
    },
    deletePriceCalculateQuestion(qid) {
      api.deletePriceCalculateQuestion(qid).then(() => {
        this.fetchList();
      });
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getPriceCalculateByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getPriceCalculateGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};